import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Layout, Space, Typography } from 'antd';

const { Title, Paragraph } = Typography;



function UsersPage() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    



    return (
        <>
            <Layout>
                <Layout.Header style={{display:'flex', flexDirection:'row'}}>
                    <Title style={{flex:1}}>Users</Title>
                    <div style={{alignContent:'center'}}>
                        <Button>Add user</Button>
                    </div>
                </Layout.Header>
                <Layout.Content className='ant-layout-page-content'>
                    
                </Layout.Content>
            </Layout>
            
        </>
    );
}

export default UsersPage;